// 物流异常预警接口

import { get, post } from "@/services/http/platformServer";
import { PremiumFunctionType } from "@/services/PremiumValidator";

export interface OrderLogisticsWarningSetting {
    /**
     * 等待时间，发货后超过这个等待时间，订单还没有物流信息的话对用户预警
     * 订单发货后，等待 n 小时之后，如果没有物流信息进行预警
     */
    afterShipHours: number;
    enable: boolean;
    /**
     * 是否开启未揽收预警
     * 预警小时设置对应{@link pickupDeadlineWarningHours}
     */
    enablePickupDeadlineWarning: boolean;
    /**
     * 未揽收预警小时
     * 订单发货后距离最后揽收时间多少小时还没有物流轨迹时进行预警
     */
    pickupDeadlineWarningHours: number;
    shopId: number;
}

// 加载当前用户所在Company下所有可见店铺的物流预警设置
export function getOrderLogisticsWarningSettings(joinedShopIds: number[]) {
    const shopId = joinedShopIds?.[0];

    return get<OrderLogisticsWarningSetting[]>(shopId, "/order_logistics_warning_setting/list", {
        joinedShopIds: joinedShopIds.join(","),
    });
}

export interface UpdateOrderLogisticsWarningSettingParams {
    shopId: number;

    /**发货后 n 小时无物流信息预警*/
    afterShipHours: number;

    enable: boolean;
}

// 更新物流预警设置，用户在前端点关闭、开启的时候调用该方法
export function updateSetting(params: UpdateOrderLogisticsWarningSettingParams) {
    return post(params.shopId, "/order_logistics_warning_setting/update_no_logistics_warning", params, {
        pathPremiumValidator() {
            return {
                shopId: params.shopId,
                type: PremiumFunctionType.ORDER_LOGISTICS_WARNING,
            };
        },
    });
}

interface UpdatePickupDeadlineWarningParams {
    shopId: number;

    enablePickupDeadlineWarning: boolean;

    pickupDeadlineWarningHours: number;
}

// 设置揽收超时预警
export function updatePickupDeadlineWarning(params: UpdatePickupDeadlineWarningParams) {
    return post(params.shopId, "/order_logistics_warning_setting/update_pickup_deadline_warning", params);
}

export default {
    getSetting: getOrderLogisticsWarningSettings,
};
